// H6 Connecteurs et intégrations (interface) : inscription du module. Les fichiers centraux (routeur, pages,
// navigation) reçoivent une ligne par module à l'intégration.

import { createElement } from 'react';
import { FicheConnecteur, PageIntegrations } from './Integrations';

export const inscription = {
  code: 'H6',
  routes: [
    { chemin: '/integrations', element: createElement(PageIntegrations) },
    { chemin: '/integrations/:id', element: createElement(FicheConnecteur) },
  ],
} as const;
